import { error } from "jquery";


//Move after quick dirty testing
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const out = String(reader.result || '');
      // quick sanity checks
      if (!out.startsWith('data:')) {
        console.warn('fileToBase64: unexpected result (no data: prefix)');
      }
      resolve(out);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file); // Reads file as base64 encoded Data URL
  });
}


let __instance = null;

// const baseUrl = "https://pre.backend.eatme.cloud/";
// const baseUrl = "https://backend.eatme.cloud/";
const baseUrl = "https://backend.munchfit.app/";

export default class API {
  #token = sessionStorage.getItem("token") || null;
  isDebugSession = window.location.hostname === "localhost";
  async login(email, pass) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: _convertToFormData({ email: email, password: pass, android_id: 0 }),
    };
    const response = await fetch(
      baseUrl + "loginWeb/admin",
      requestOptions
    ).catch(() => {
      return false;
    });
    if (response.ok) {
      const body = await response.json();
      console.log("sessionstorage");
      console.log(body);
      console.log(response);
      sessionStorage.setItem("token", body.token);
      sessionStorage.setItem("userid", body.user._id);
      sessionStorage.setItem("superuser", body.user.super);
      sessionStorage.setItem("doctor", body.doctor);
      sessionStorage.setItem("user", JSON.stringify(body.user));
      sessionStorage.setItem("patients", JSON.stringify(body.user.patients));
      sessionStorage.setItem("name", body.user.name);
      /*       console.log(sessionStorage); */
      this.#token = body.token;
      return true;
    } else {
      return false;
    }
  }

  async logout() {
    this.#token = null;
    sessionStorage.clear();

    return true;
  }

  static instance() {
    if (__instance == null) __instance = new API();

    return __instance;
  }

  async findAdmins() {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(_getDataAccess()),
    };
    const response = await fetch(
      baseUrl + "administration/getAll",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async createAdmin(admin) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(admin, _getDataAccess())),
    };
    const response = await fetch(baseUrl + "administration", requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async deleteAdmin(adminId) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign({ _id: adminId }, _getDataAccess())),
    };
    const response = await fetch(
      baseUrl + "administration/delete",
      requestOptions
    );
    if (response.ok) {
      return true;
    } else {
      throw new Error(response.status);
    }
  }

  async updateAdmin(admin) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(admin, _getDataAccess())),
    };
    const response = await fetch(
      baseUrl + "administration/update",
      requestOptions
    );
    if (response.ok) {
      return true;
    } else {
      throw new Error(response.status);
    }
  }

  async findAliments() {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(_getDataAccess()),
      dataType: "json",
    };
    const response = await fetch(baseUrl + "nifi/getAllFood", requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async createAliment(aliment) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ..._getDataAccess(), ...aliment }),
    };
    const response = await fetch(baseUrl + "nifi/putFood", requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }
  async updateAliment(aliment) {
    let id = aliment._id;
    delete aliment._id;
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        foodID: id,
      },
      body: JSON.stringify({ ..._getDataAccess(), ...aliment }),
    };
    const response = await fetch(baseUrl + "nifi/updateFood", requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async deleteAliment(alimentId) {
    const requestOptions = {
      method: "POST",
      headers: {
        foodID: alimentId,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(_getDataAccess()),
    };
    const response = await fetch(baseUrl + "nifi/deleteFood", requestOptions);
    if (response.ok) {
      return true;
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async findProducts() {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(_getDataAccess()),
    };
    console.log(requestOptions);
    const response = await fetch(
      baseUrl + "webStore/getStoreProducts",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async createProduct(product) {
    console.log("product");
    console.log(product);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody({ ..._getDataAccess(), ...product }),
    };
    console.log("requestOptions product:");
    console.log(requestOptions);
    const response = await fetch(
      baseUrl + "webStore/saveStoreProduct",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async updateProduct(product) {
    delete product.user_id;
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody({ ..._getDataAccess(), ...product }),
    };
    const response = await fetch(
      baseUrl + "webStore/updateStoreProduct",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async deleteProduct(id) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody({ ..._getDataAccess(), ...{ _id: id } }),
    };
    const response = await fetch(
      baseUrl + "webStore/deleteStoreProduct",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async findOrders() {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(_getDataAccess()),
    };
    /*     console.log(requestOptions);
     */ const response = await fetch(
      baseUrl + "webStore/getStorePurchases",
      requestOptions
    );
    console.log("response");
    console.log(response);
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async updateOrder(order) {
    delete order.user_id;

    let updatedOrder = JSON.stringify(order);
    console.log("updatedOrder", updatedOrder);

    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ..._getDataAccess(), ...order }),
    };
    console.log("order", JSON.stringify(order.products));
    console.log(requestOptions);
    const response = await fetch(
      baseUrl + "webStore/updateStorePurchase",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async deleteOrder(id) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody({ ..._getDataAccess(), ...{ _id: id } }),
    };
    const response = await fetch(
      baseUrl + "webStore/deleteStoreProduct", //FIXME: fix url when endpoint done
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async findArticles() {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(_getDataAccess()),
    };
    const response = await fetch(
      baseUrl + "saveVideoArticle/getVideoArticles",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async createArticle(article) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody({ ..._getDataAccess(), ...article }),
    };
    const response = await fetch(
      baseUrl + "saveVideoArticle/web",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  //Ojo, se utiliza también con vídeos
  async updateArticle(article) {
    delete article.user_id;
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody({ ..._getDataAccess(), ...article }),
    };
    const response = await fetch(
      baseUrl + "saveVideoArticle/update",
      requestOptions
    );
    console.log(`REQUEST updateArticle ${JSON.stringify(article)} `)
    if (response.ok) {
      const properResponse = await response.json();

      console.log(`RESPONSE updateArticle ${JSON.stringify(properResponse)} `)
      return properResponse
    } else {
      throw new Error(response.status);
    }
  }

  async deleteArticle(id) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody({ ..._getDataAccess(), ...{ _id: id } }),
    };
    const response = await fetch(
      baseUrl + "saveVideoArticle/delete",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async findDoctorAppointments(id) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody({
        ..._getDataAccess(),
        ...{ id_doctor: id, timestamp: Date.now() / 1000 },
      }),
    };
    const response = await fetch(
      baseUrl + "webHoursDoctors/getAllHours",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async findDoctors() {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(_getDataAccess()),
    };
    const response = await fetch(
      baseUrl + "webDoctors/getDoctors",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async createDoctor(doctor) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(doctor, _getDataAccess())),
    };
    const response = await fetch(baseUrl + "webDoctors", requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async deleteDoctor(doctorId) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign({ _id: doctorId }, _getDataAccess())),
    };
    const response = await fetch(baseUrl + "webDoctors/delete", requestOptions);
    if (response.ok) {
      return true;
    } else {
      throw new Error(response.status);
    }
  }

  async updateDoctor(doctor) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(doctor, _getDataAccess())),
    };
    const response = await fetch(
      baseUrl + "webDoctors/updateDoctor",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }


  // async findMyselfDoctor() {
  //   const requestOptions = {
  //     method: "POST",
  //     credentials: "include",
  //     headers: {
  //       "Content-Type": this._getContentType(),
  //     },
  //     body: this._buildBody(_getDataAccess()),
  //   };
  //   const response = await fetch(
  //     baseUrl + "webDoctors/updateDoctor",
  //     requestOptions
  //   );
  //   if (response.ok) {
  //     return await response.json();
  //   } else {
  //     throw new Error(response.status);
  //   }
  // }


  async findForms(id) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign({ _id: id }, _getDataAccess())),
    };
    const response = await fetch(
      baseUrl + "saveWebUser/getHistory",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async createForm(form) {
    //Parse RICH_TEXT_AREA text to natural text
    form.text = atob(form.text);
    form.text_user = atob(form.text_user);
    let name = sessionStorage.getItem("name");
    form.dr_name = name;
    console.log("form antes de files:", form);
    form.date_id = form.session;

    //Handle files upload
    /*  let urls = [];
    let visible_user = [];
    let index = 0;
    let fileUploadPromises = [];
    while (form[`file${index}`] && form[`file${index}`].size) {
        url.push(form[`file${index}`]);
      visible_user.push(form[`file${index}`].name); 

      const file = form[`file${index}`];
      fileUploadPromises.push(
        this.addFilesToForm(file, form.doctor_id, form.user_id)
          .then((response) => {
            urls.push(response);
            visible_user.push(file.name);
          })
          .catch((error) => {
            console.error(`Error al subir el archivo ${file.name}:`, error);
          })
      );
      ++index;
    } */

    /*     await Promise.all(fileUploadPromises);

    form = { ...form, urls, visible_user };
    console.log("form creado:", form); */

    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(form, _getDataAccess())),
    };
    console.log("formmm", form);
    const response = await fetch(
      baseUrl + "saveWebUser/saveHistory",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async updateForm(form) {
    //Parse RICH_TEXT_AREA text to natural text
    form.text = atob(form.text);
    form.text_user = atob(form.text_user);

    console.log("form a actualizar:", form);

    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(form, _getDataAccess())),
    };
    const response = await fetch(
      baseUrl + "saveWebUser/updateHistory",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async deleteForm(id) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(
        Object.assign({ history_id: id }, _getDataAccess())
      ),
    };
    const response = await fetch(
      baseUrl + "saveWebUser/deleteLastSession",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  /*   async addFilesToForm(file, doctor_id, user_id) {
    console.log("llamada a addFilesToForm", file);
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      body: this._buildBody(
        Object.assign(
          { file: file, doctor_id: doctor_id, patient_id: user_id },
          _getDataAccess()
        )
      ),
    };
    const response = await fetch(
      baseUrl + "saveWebUser/uploadFileHistory",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  } */

  async createMediaPdfFile(
    folder,
    id,
    media,
    filename = "",
    isThumbnail = false,
    type = "Image",
    visible_for_user
  ) {
    console.log("ENTRO", id);
    let formData = new FormData();
    let data = type === "Image" ? { img: media } : { video: media };
    formData.append(type === "Image" ? "img" : "video", media);
    formData.append("doctor_id", _getDataAccess().user_id);
    formData.append("token", _getDataAccess().token);
    formData.append("android_id", _getDataAccess().android_id);
    formData.append("history_id", id);
    formData.append("visible_for_user", visible_for_user);
    console.log("formData" + JSON.stringify(formData));
    console.log("visible_for_user:" + visible_for_user);
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        Folder: folder + id,
        videoarticleid: id,
        portada: isThumbnail,
        "Content-Type": "application/json",
        Token: sessionStorage.getItem("token"),
        Userid: sessionStorage.getItem("userid"),
        File: filename
          ? filename
          : "TYPI_PID" +
          id +
          "_UID" +
          _getDataAccess().user_id +
          "_TS" +
          new Date().getTime(),
      },
      body: JSON.stringify(
        Object.assign(
          _getDataAccess(),
          { ...data, history_id: id, visible_for_user },
          {
            doctor_id: _getDataAccess().user_id,
          }
        )
      ),
    };

    const response = await fetch(
      baseUrl + "saveWebUser/uploadFileHistory",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      console.error("response")
      throw new Error(`${response.status} ${error.message}`);
    }
  }

  async deleteMediaPdfFile(folder, history_id, filename) {
    let url_file = "";
    let only_for_user = false;

    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
        Token: sessionStorage.getItem("token"),
        Userid: sessionStorage.getItem("userid"),
      },
    };
    const response = await fetch(
      baseUrl + "saveWebUser/deleteFileHistory",
      requestOptions
    );
    if (response.ok) {
      return true;
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async findMedia(folder, id) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        Folder: folder + "/" + id, //@updated by alex
        Token: sessionStorage.getItem("token"),
        Userid: sessionStorage.getItem("userid"),
      },
    };

    function _arrayBufferToBase64(buffer) {
      let binary = "";
      let bytes = new Uint8Array(buffer);
      let len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    }

    const response = await fetch(baseUrl + "listdir/", requestOptions);
    if (response.ok) {
      let media = {};
      let string = await response.text();
      const array = string
        ?.replaceAll(/[\[\]' ]/g, "")
        .split(",")
        .filter(Boolean);
      for (const mediaId of array) {
        if (mediaId == "img") {
          continue;
        }
        requestOptions.method = "GET";
        const response = await fetch(
          baseUrl + "private/" + folder + "/" + id + "/" + mediaId,
          requestOptions
        );
        if (response.ok) {
          let buffer = await response.arrayBuffer();
          media[mediaId] = _arrayBufferToBase64(buffer);
        }
      }
      return media;
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  /* Para enviar archivos al backend (usan una estrucura no no estándar, el archivo va como base 64)
  Diría que hay bastante lógica repetida y que nadie sabe de dónde vienen los problemas en este punto  
  (e.g., el body contiene lo que ya contiene el header también en cuanto a autenticación)
  */
  async createMedia(
    folder,
    id,
    media,
    filename = "",
    isThumbnail = false,
    type = "Image"
  ) {
    console.log("upload file!")
    console.log("folder:" + folder)
    console.log("id:" + id)
    console.log("media:" + media)
    console.log("filename:" + filename)
    console.log("isThumbnail:" + isThumbnail)
    console.log("type:" + type)

    let formData = new FormData();
    let data = type === "Image" ? { img: media } : { video: media };
    formData.append(type === "Image" ? "img" : "video", media);
    formData.append("user_id", _getDataAccess().user_id);
    formData.append("token", _getDataAccess().token);
    formData.append("android_id", _getDataAccess().android_id);
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        Folder: folder + id + (isThumbnail ? "/img" : ""),
        videoarticleid: id,
        portada: isThumbnail,
        "Content-Type": "application/json",
        Token: sessionStorage.getItem("token"),
        Userid: sessionStorage.getItem("userid"),
        android_id: 0,
        File: filename
          ? filename
          : "TYPI_PID" +
          id +
          "_UID" +
          _getDataAccess().user_id +
          "_TS" +
          new Date().getTime(),
      },
      body: JSON.stringify(Object.assign(_getDataAccess(), data)),
    };
    console.log("REQUEST OPTIONS");
    console.log(requestOptions);
    console.log("BASE URL");
    console.log(baseUrl + "query/upload" + type);
    const response = await fetch(
      baseUrl + "query/upload" + type,
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(`${response.status} ${response.statusText} ${JSON.stringify(await response.json())}`);
    }
  }

  async createMediaSOSWithBase64(folder, id, media, filename = "", isThumbnail = false, type = "Image", visible_for_user = true) {
    console.log("Reading file to base64...");
    let base64File = await fileToBase64(media);





    //data:application/pdf;base64,JVBERi0xLjcKJcOkw7zDtsOfCjIgMCBvYmoKPDwvTGVuZ3R
    console.log("the data that i will be sending is the following", base64File.slice(0, 100))

    // 1) Strip known prefixes (data:… or leading "base64")
    // base64File = base64File.trim()
    //   .replace(/^base64,/i, '')
    //   .replace(/^data:application\/pdf;base64,/i, '');




    const data = {
      ..._getDataAccess(),
      [type === "Image" ? "img" : "video"]: base64File,
      visible_for_user: visible_for_user,
    };

    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        Folder: `${folder}/${id}` + (isThumbnail ? "/img" : ""),
        videoarticleid: id,
        portada: isThumbnail,
        "Content-Type": "application/json",
        Token: sessionStorage.getItem("token"),
        Userid: sessionStorage.getItem("userid"),
        android_id: 0,
        File: filename
          ? filename
          : "TYPI_PID" + id + "_UID" + _getDataAccess().user_id + "_TS" + new Date().getTime(),
      },
      body: JSON.stringify(data),
    };

    console.log(`Sending request to ${baseUrl + "query/upload" + type}...`);
    const response = await fetch(baseUrl + "query/upload" + type, requestOptions);

    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(`${response.status} ${response.statusText}`);
    }
  }
  async createMediaSOSJustFormData(
    folder,
    id,
    media,
    filename = "",
    isThumbnail = false,
    type = "Image"
  ) {
    console.log("upload file!");
    console.log("folder:", folder);
    console.log("id:", id);
    console.log("media:", media);
    console.log("filename:", filename);
    console.log("isThumbnail:", isThumbnail);
    console.log("type:", type);

    const formData = new FormData();
    formData.append(type === "Image" ? "img" : "video", media);
    formData.append("user_id", _getDataAccess().user_id);
    formData.append("token", _getDataAccess().token);
    formData.append("android_id", _getDataAccess().android_id);

    const filenameHeader =
      filename ||
      `TYPI_PID${id}_UID${_getDataAccess().user_id}_TS${new Date().getTime()}`;

    const response = await fetch(baseUrl + "query/upload" + type, {
      method: "POST",
      credentials: "include",
      headers: {
        Folder: folder + id + (isThumbnail ? "/img" : ""),
        videoarticleid: id,
        portada: isThumbnail.toString(),
        Token: sessionStorage.getItem("token"),
        Userid: sessionStorage.getItem("userid"),
        android_id: "0",
        File: filenameHeader,
        // DO NOT set Content-Type when using FormData!
      },
      body: formData,
    });

    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(`${response.status} ${response.statusText}`);
    }
  }



  //MEDIA but for products, as url is hardcoded

  async createMediaProduct(
    folder,
    id,
    media,
    filename = "",
    isThumbnail = false,
    type = "Image"
  ) {
    let formData = new FormData();
    let data = type === "Image" ? { img: media } : { video: media };
    formData.append(type === "Image" ? "img" : "video", media);
    formData.append("user_id", _getDataAccess().user_id);
    formData.append("token", _getDataAccess().token);
    formData.append("android_id", _getDataAccess().android_id);
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        Folder: folder + id,
        videoarticleid: id,
        portada: isThumbnail,
        "Content-Type": "application/json",
        Token: sessionStorage.getItem("token"),
        Userid: sessionStorage.getItem("userid"),
        File: filename
          ? filename
          : "TYPI_PID" +
          id +
          "_UID" +
          _getDataAccess().user_id +
          "_TS" +
          new Date().getTime(),
      },
      body: JSON.stringify(Object.assign(_getDataAccess(), data)),
    };
    console.log("REQUEST OPTIONS");
    console.log(requestOptions);
    console.log("BASE URL");
    console.log(baseUrl + "webStore/upload" + type);
    const response = await fetch(
      baseUrl + "webStore/upload" + type,
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async deleteMedia(folder, id, filename) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        Folder: folder + id,
        File: filename,
        "Content-Type": this._getContentType(),
        Token: sessionStorage.getItem("token"),
        Userid: sessionStorage.getItem("userid"),
      },
    };
    const response = await fetch(baseUrl + "delete/", requestOptions);
    if (response.ok) {
      return true;
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async sendMessage(message) {
    console.log("message", message);
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ..._getDataAccess(), ...message }),
    };
    console.log("requestOptions sendMessage", requestOptions);
    const response = await fetch(
      baseUrl + "getFirebaseToken/sendMessage",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async findMyself() {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(_getDataAccess()),
    };
    const response = await fetch(
      baseUrl + "administration/getMyself",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async updateMyself(data) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(data, _getDataAccess())),
    };
    const response = await fetch(
      baseUrl + "administration/updateMyself",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async updatePassword(newData) {
    const data = {
      password: newData.password,
      passRepe: newData.passwordVerification,
    };
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(data, _getDataAccess())),
    };
    const response = await fetch(
      baseUrl + "administration/changeMyPW",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async findNewUsers(query) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
        Token: sessionStorage.getItem("token"),
        Userid: sessionStorage.getItem("userid"),
      },
    };
    const response = await fetch(
      "https://test.incitytogether.io/stats/getNewUsers" + query,
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async findLogs() {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(_getDataAccess()),
    };
    const response = await fetch(
      baseUrl + "eatmeLogs/getPaged",
      requestOptions
    );
    if (response.ok) {
      return response.json().then((body) => {
        body?.data.map((log) => {
          return {
            timestamp: log[0],
            type: log[1],
            call: log[2],
            message: log[3],
            user: log[4],
            logs: log[5],
          };
        });
      });
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async findRecipes() {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(_getDataAccess()),
    };
    const response = await fetch(
      baseUrl + "nifi/getAllRecipes",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async createRecipe(recipe) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(Object.assign(recipe, _getDataAccess())),
    };
    const response = await fetch(baseUrl + "nifi/putRecipe", requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async testRecipe(recipe) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(
        Object.assign({ blueprint: recipe }, _getDataAccess())
      ),
    };
    const response = await fetch(baseUrl + "testRecipe", requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async updateRecipe(recipe) {
    let id = recipe._id;
    delete recipe._id;
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        recipeID: id,
      },
      body: JSON.stringify(Object.assign(recipe, _getDataAccess())),
    };
    const response = await fetch(baseUrl + "nifi/updateRecipe", requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async deleteRecipe(recipeId) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        recipeID: recipeId,
      },
      body: JSON.stringify(_getDataAccess()),
    };
    const response = await fetch(baseUrl + "nifi/deleteRecipe", requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async findUsedHours(query) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(_getDataAccess(), query)),
    };
    const response = await fetch(
      baseUrl + "webHours/getHorasOcupadas",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }
  async findUser(id) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(_getDataAccess(), { _id: id })),
    };
    console.log("requestOptions", requestOptions);
    const response = await fetch(
      baseUrl + "saveWebUser/getOne",
      requestOptions
    );
    if (response.ok) {
      console.log("LLEGA USER");
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async findUserDiets(id) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(
        Object.assign(_getDataAccess(), { id_usuario: id })
      ),
    };
    const response = await fetch(
      baseUrl + "webDiets/getDietsV3",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async findUsers() {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(_getDataAccess()),
    };
    const response = await fetch(
      baseUrl + "saveWebUser/getAllUsers",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async findUserAppointments(id) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ..._getDataAccess(),
        ...{
          _id: id,
          id_usuario: id,
          timestamp: Date.now() / 1000,
          doctor_id: sessionStorage.getItem("userid"),
        },
      }),
    };
    const response = await fetch(
      baseUrl + "webHours/getAllHours",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async createUserAppointment(appointment) {
    appointment.timestamp = appointment.horas_reservadas;
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ..._getDataAccess(),
        ...appointment,
      }),
    };
    const response = await fetch(
      baseUrl + "webHours/saveDateDoctor",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async deleteUserAppointment(id) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ..._getDataAccess(),
        ...{ date_id: id },
      }),
    };
    console.log("requestOptions", requestOptions);
    const response = await fetch(
      baseUrl + "webHoursDoctors/delete",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async createUser(user) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(user, _getDataAccess())),
    };
    const response = await fetch(baseUrl + "saveWebUser", requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async deleteUser(userId) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign({ _id: userId }, _getDataAccess())),
    };
    const response = await fetch(
      baseUrl + "saveWebUser/delete",
      requestOptions
    );
    if (response.ok) {
      return true;
    } else {
      throw new Error(response.status);
    }
  }

  async updateUser(user) {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(user, _getDataAccess())),
    };
    const response = await fetch(
      baseUrl + "saveWebUser/update",
      requestOptions
    );
    if (response.ok) {
      return true;
    } else {
      throw new Error(response.status);
    }
  }

  async findValidate(id) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody({ url: id }),
    };
    const response = await fetch(
      baseUrl + "webDoctors/getOneConfirm",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async confirmDoctor(doctor) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(doctor),
    };
    const response = await fetch(
      baseUrl + "webDoctors/confirmDoctor",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async findValidates() {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(_getDataAccess()),
    };
    const response = await fetch(
      baseUrl + "webDoctors/getValidates",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }

  async getLegend() {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // 'Access-Control-Allow-Origin' : 'no-cors'

      },
      body: JSON.stringify(_getDataAccess()),
    };
    const response = await fetch(baseUrl + "nifi/getAllLegend", requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async findStats(stat) {
    let url = baseUrl + "stats/";
    let start = new Date();
    let end = new Date();
    switch (stat) {
      case "week":
        url += "getWAUCustom";
        start.setDate(end.getDate() - 7);
        break;
      case "twoWeeks":
        url += "get15DAUCustom";
        start.setDate(end.getDate() - 15);
        break;
      case "month":
        url += "getMAUCustom";
        start.setDate(end.getDate() - 30);
        break;
      case "sixMonths":
        url += "get6MAUCustom";
        start.setDate(end.getDate() - 180);
        break;
      default:
        break;
    }
    let body = {
      start: ~~(start.getTime() / 1000),
      end: ~~(end.getTime() / 1000),
    };
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody({ ..._getDataAccess(), ...body }),
    };
    const response = await fetch(url, requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      console.log(response);
      throw new Error(response.status);
    }
  }

  async uploadSpreadsheet(file, sheetNames) {
    const requestOptions = {
      headers: {
        sheetNames: sheetNames,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        ..._getDataAccess(),
        ...{
          file: {
            mime: "@file/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            data: file.substring(file.indexOf(";") + 1).replace("base64,", ""),
          },
        },
      }),
    };
    console.log("REQUEST OPTIONS");
    console.log(requestOptions);
    const response = await fetch(baseUrl + "nifi/setExcel", requestOptions);
    if (response.ok) {
      return await response.json();
    } else {
      console.log(await response.json());
      throw new Error(response.status);
    }
  }



  //NEW
  async updatePasswordAsNutritionist(newData) {
    const data = {
      password: newData.password,
      passRepe: newData.passwordVerification,
      ...newData
    };
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": this._getContentType(),
      },
      body: this._buildBody(Object.assign(data, _getDataAccess())),
    };
    const response = await fetch(
      baseUrl + "webDoctors/changeMyPW",
      requestOptions
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(response.status);
    }
  }






  _getContentType() {
    if (this.isDebugSession) {
      return "application/x-www-form-urlencoded";
    } else {
      return "application/json";
    }
  }

  _buildBody(json) {
    if (this.isDebugSession) {
      return _convertToFormData(json);
    } else {
      return JSON.stringify(json);
    }
  }
}

function _convertToFormData(json) {
  let formBody = [];
  for (const [key, value] of Object.entries(json)) {
    formBody.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
  }
  return formBody.join("&");
}

function _getDataAccess() {
  return {
    user_id: sessionStorage.getItem("userid"),
    token: sessionStorage.getItem("token"),
    android_id: 0,
  };
}
